import { render, staticRenderFns } from "./SectionISoci.vue?vue&type=template&id=8d83ba16&scoped=true&"
import script from "./SectionISoci.vue?vue&type=script&lang=js&"
export * from "./SectionISoci.vue?vue&type=script&lang=js&"
import style0 from "./SectionISoci.vue?vue&type=style&index=0&id=8d83ba16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d83ba16",
  null
  
)

export default component.exports